// removed by extract-text-webpack-plugin
module.exports = {"creat-subaccount-form":"_1qFvyrpp_7NKL6qHcYaHxH","ant-input-group-wrapper":"_1E2_sQboV4zfGSrL2WJtaY","ant-form-item-control":"_2oZpMBYhHBo1vtfHu_BTmQ","ant-form-item":"_3FlGaSmdarPXXHbYO__UCY","ant-form-item-label":"_3WcAzefU0kOG-DgRMqBjpA"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/SubAccountManagement/style.less
// module id = 785
// module chunks = 0